var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_7699)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.015625,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#28A745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.995 1.39258C3.235 1.39258 1 3.63258 1 6.39258C1 9.15258 3.235 11.3926 5.995 11.3926C8.76 11.3926 11 9.15258 11 6.39258C11 3.63258 8.76 1.39258 5.995 1.39258ZM6 10.3926C3.79 10.3926 2 8.60258 2 6.39258C2 4.18258 3.79 2.39258 6 2.39258C8.21 2.39258 10 4.18258 10 6.39258C10 8.60258 8.21 10.3926 6 10.3926ZM5.89 3.89258H5.86C5.66 3.89258 5.5 4.05258 5.5 4.25258V6.61258C5.5 6.78758 5.59 6.95258 5.745 7.04258L7.82 8.28758C7.99 8.38758 8.21 8.33758 8.31 8.16758C8.415 7.99758 8.36 7.77258 8.185 7.67258L6.25 6.52258V4.25258C6.25 4.05258 6.09 3.89258 5.89 3.89258Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_7699"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.015625,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockWhite);
export default __webpack_public_path__ + "static/media/clockWhite.47296896d7c664aab480e0d4063925c8.svg";
export { ForwardRef as ReactComponent };